export default __webpack_public_path__ + "static/media/paymentonboarding2.c7f7f375.svg";